import styled from '@emotion/styled/macro';
import { Box, Flex } from '@chakra-ui/react';
import React, { FC } from 'react';
import { ReactComponent as Receipt } from '../../assets/svgs/receipt.svg';
import { mq } from 'styles/breakpoints';
import { rem } from 'utils/fonts';

interface Props {
  longText?: boolean;
  arrow?: boolean;
}

const Wrapper = styled(Flex)<{ arrow?: boolean }>`
  width: 100%;
  min-height: 75px;
  align-items: center;
  padding: 20px;
  position: relative;

  &:after {
    display: ${(props): string => (props.arrow ? 'block' : 'none')};
    content: '';
    position: absolute;
    left: 13px;
    top: -8px;
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    transform: rotate(90deg);
  }
`;

const IconWrapper = styled(Box)`
  height: 33px;
`;

const Text = styled(Box)<Props>`
  font-weight: normal;
  font-size: ${rem(12)};
  line-height: 135%;
  margin-left: 20px;

  ${mq.md} {
    max-width: ${(props): string => (props.longText ? '100%' : '205px')};
  }
`;

const Infobox: FC<Props> = ({ longText, arrow, children }) => {
  return (
    <Wrapper arrow={arrow} layerStyle="infobox" borderRadius="base">
      <IconWrapper sx={{ path: { fill: 'primary.700' } }}>
        <Receipt />
      </IconWrapper>
      <Text longText={longText} color="gray.900">
        {children}
      </Text>
    </Wrapper>
  );
};

export default Infobox;
